import { useHasPermission } from "../../auth/useClaims";

// Guard Assignments (the Customer detail screen's tab + standalone Bulk
// Guards screen) split off from Customers.Edit into their own permission
// (handoff §13.4, shipped same day as §13.3) - a CRM/sales role that can
// edit a customer's own contact/address fields shouldn't necessarily be
// able to deploy guards, and vice versa. Covers all three write endpoints
// (replace rows, activate/deactivate status, bulk-create) - bulk-create was
// deliberately not split into its own permission, same Deployment.Edit as
// everything else on this screen. No all-branch check needed, same as
// Customers.Edit - the API already scopes by the caller's own branch(es).
// Renamed server-side from Guards.Edit/.View to Deployment.Edit/.View
// (module GUARDS -> DEPLOYMENT) on 2026-08-05 - this file wasn't updated
// at the time, so the old code silently matched nothing until fixed here.
export const useCanEditGuardAssignments = () => useHasPermission("Deployment.Edit");
